import React from "react";

export default function EmptyMask(props) {
    const message = props.message ? props.message : window.captions.NoAvailableItems;
    const className = props.inline ? "dm-error-inline" : "dm-error-block";
    return <div className={className} style={props.style}>
        <span className="badge bg-secondary">{message}</span>
    </div>;
}